const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuMTgyIDRDMjIuMTg2IDQgMjMgNC44OTUgMjMgNnYxMmMwIDEuMTA1LS44MTQgMi0xLjgxOCAySDIuODE4QzEuODE0IDIwIDEgMTkuMTA1IDEgMThWNmMwLTEuMTA1LjgxNC0yIDEuODE4LTJoMTguMzY0ek0yMSA2SDN2MTJoMThWNnpNNyAxNHYySDV2LTJoMnptNCAwdjJIOHYtMmgzem04IDB2MmgtMnYtMmgyem0tMyAwdjJoLTJ2LTJoMnpNOCA5djNINVY5aDN6IiAgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export {
  M as default
};
//# sourceMappingURL=pay-3e14f441.mjs.map
